<template>
    <tbody>
    <tr v-for="item in items" data-uk-rr-grid-item>
        <td>
            <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.order_ref') }}</strong>
            {{item.present}}
        </td>
        <td>
                <span v-if="item.completed_at.diff">
                <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.date') }}</strong>
                {{item.completed_at.diff}}
                </span>
        </td>
        <td>
            <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.total_amount') }}</strong>
            {{Utils.Currencies.toHuman(item.total)}}
        </td>
        <td>
            <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.payment') }}</strong>
            {{item.payment}}
        </td>
        <td>
            <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.shipping_method') }}</strong>
            {{item.shipping}}
        </td>
        <td>
            <strong class="uk-display-block uk-hidden@m">{{ $t('rubinred.ecommerce.core.common.orders.status') }}</strong>
            <span class="uk-text-warning" v-if="item.state === 'new'"><i class="fal fa-exclamation-circle"></i> {{ $t('rubinred.ecommerce.core.common.status.waiting') }}</span>

            <span class="uk-text-danger" v-if="item.state === 'cancelled'"><i class="fal fa-times-circle"></i> {{ $t('rubinred.ecommerce.core.common.status.deleted') }}</span>

            <span class="uk-text-success" v-if="item.state === 'fulfilled'"><i class="fal fa-check-circle"></i> {{ $t('rubinred.ecommerce.core.common.status.shipped') }}</span>
        </td>
        <td>
            <a :href="item.link" class="uk-button uk-button-primary uk-button-small uk-width-1-1">{{ $t('rubinred.ecommerce.core.action.detail') }}</a>
        </td>
    </tr>
    </tbody>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/grid/OrdersDataGridResults.vue